const stringToAvatar = (value) =>
  value &&
  value
    .split(' ')
    .splice(0, 3)
    .reduce((initials, part) => `${initials}${part[0]}`, '')
    .toUpperCase();

export default stringToAvatar;
